import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import RealEstateServices from "./sections/RealEstateServices";
import DigitalVisibilityServices from "./sections/DigitalVisibilityServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Hero />
      <RealEstateServices />
      <DigitalVisibilityServices />
      <Footer />
    </div>;
}